<template>
  <div class="tags-box">
    <el-dialog :title="'标签编辑'" :visible.sync="dialogVisible" width="500px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="editParam" label-width="55px">
        <el-form-item label="标签:">
          <el-input type="textarea" :rows="3" placeholder="内容以“，”号隔开，如“张三，李四”" v-model="tagList"> </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitTag" size="small" :loading="flag">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'

export default {
  data() {
    return {
      dialogVisible: false,
      tagList: '',
      coverMap: '',
      textarea: '',
      flag: false,
      editParam: {
        id: '',
        type: 1,
        tags: []
      },
    }
  },
  methods: {
    // 打开弹窗并初始化tags数据
    open(row, pic) {
      this.dialogVisible = true
      this.coverMap = pic
      this.editParam.id = row.id
      if (!row.tags) {
        this.tagList = ''
        return false
      }
      let tagList = []
      row.tags.forEach(item => {
        tagList.push(item.name)
      })
      this.tagList = tagList.join('，')
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
    },
    // 提交tags
    submitTag() {
      if (!this.tagList) {
        this.$message.error('标签不能为空！');
        return false
      }
      this.flag = true
      this.editParam.tags = this.tagList.split("，")
      API.editVideoInfo(this.editParam).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '编辑成功！',
            type: 'success'
          });
          this.$emit("handlerVideoList")
        } else {
          this.$message.error('编辑失败！');
        }
        this.handleClose()
        this.flag = false
      }).catch(() => {
        this.handleClose()
        this.flag = false
      })
    },
  }
}
</script>

<style scoped lang="scss">
.tags-box {
  .input-box {
    margin-top: 15px;
    text-align: left;
  }
  .el-input {
    width: 200px;
    margin-right: 10px;
  }
}
</style>
